/**
 * @file Renders a form field's extra helper text, with an optional info icon.
 */
import React from "react";
import { InfoCircleOutlined } from "@ant-design/icons";

import { W0, W1, W2, isMobile } from "@components/Constants";

type Props = {
  text: string;
  hasIcon?: boolean;
};

/**
 * Renders a form field's extra helper text, with an optional info icon.
 */
const InputExtra = ({ text, hasIcon = true }: Props): JSX.Element => {
  const containerStyle = {
    fontSize: 12,
    marginTop: W0,
  };

  const shouldShowIcon = hasIcon;

  if (!shouldShowIcon) {
    return <div style={containerStyle}>{text}</div>;
  }

  const iconStyle = {
    float: "left" as const,
    marginTop: 2,
  };

  const textStyle = {
    marginLeft: isMobile ? W2 + 1 : W1 + 2,
  };

  return (
    <div style={containerStyle}>
      <InfoCircleOutlined style={iconStyle} />

      <div style={textStyle}>{text}</div>
    </div>
  );
};

export default InputExtra;
